import axios from '../../axios/index.js'

export default {
  reviewList(data) {
    return axios.get('/review_order/list',{params:data})
  },
  reviewDetails(order_id) {
    return axios.get('review_order/details/' + order_id)
  },
  reviewBarPlot(filter,data) {
    return axios.get('review_order/bar_plot/' + filter,{params:data})
  },
  reviewDonutPlot(data) {
    return axios.get('review_order/donutInfo',{params:data})
  },
  reviewGetLoadOrders(review_order_id) {
    return axios.get('review_order/get_load_orders/' + review_order_id)
  },
  reviewGetInvoices(review_order_id) {
    return axios.get('review_order/get_invoices/' + review_order_id)
  },
  reviewGetFiles(review_order_id) {
    return axios.get('review_order/get_files/' + review_order_id)
  },
  reviewGetEntries(review_order_id) {
    return axios.get('review_order/get_entries/' + review_order_id)
  },
  getReviewTimeline(review_order_id) {
    return axios.get('/review_order/timeline/'+review_order_id)
  },
  getReviewCards(data) {
    return axios.get('/review_order/cards',{params:data})
  },
  getReviewStatus() {
    return axios.get('/review_order/status_list')
  },
  storeInvoiceItems(data) {
    return axios.post('/review_order/invoice_items',data)
  },
  checkInvoiceItems(data) {
    return axios.post('/review_order/check_invoice',data)
  },
  deleteEntries(data) {
    return axios.post('/review_order/delete_entries',data)
  },
  updateStatus(data) {
    return axios.post('/review_order/update_status',data)
  },
  validateUpdateTxtFile(data){
    return axios.post('/review_order/validate_update_txt_file',data)
  },
  isROanswer(data){
    return axios.post('/review_order/is_ro_answer',data)
  },
  speedMeter(id){
    return axios.get('/review_order/speed_meter/'+id)
  },
  uploadFtpFiles(data){
    return axios.post('review_order/upload_ftp_files',data)
  }  
}
